import { ldapConstants } from '../constants/ldap.constants';
import ldapService from '../services/ldap.service';
import { alertActions } from './alert.actions';
import { history } from '../helpers';

export const ldapActions = {
  create,
  update,
  remove,  
  fetch,  
  test,
  get  
};

function create (obj) {
  return async dispatch => {
    dispatch(request());

    try {
      const ldapServer = await ldapService.create(obj);
      dispatch(success(ldapServer));
      dispatch(alertActions.success("Servidor criado"));
      history.push('/ldap');
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: ldapConstants.CREATE_REQUEST } }
  function success(ldapServer) { return { type: ldapConstants.CREATE_SUCCESS, ldapServer } }
  function failure(error) { return { type: ldapConstants.CREATE_FAILURE, error } }
}

function update (id, obj) {
  return async dispatch => {
    dispatch(request());

    try {
      const ldapServer = await ldapService.update(id, obj);
      dispatch(success(ldapServer));
      dispatch(alertActions.success("Servidor alterado"));
      history.push('/ldap');
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: ldapConstants.UPDATE_REQUEST } }
  function success(ldapServer) { return { type: ldapConstants.UPDATE_SUCCESS, ldapServer } }
  function failure(error) { return { type: ldapConstants.UPDATE_FAILURE, error } }
}

function test (id, obj) {
  return async dispatch => {
    dispatch(request());

    try {
      const testResult = await ldapService.test(id, obj);
      if (testResult.authenticated) {
        dispatch(success({ error: false, message: "Autenticado com sucesso" }));      
      } else {
        dispatch(success({ error: true, message: "Usuário ou senha incorreto" }));      
      }
    } catch(error) {
      if (error.response && error.response.data) {
        dispatch(failure({ error: true, message: error.response.data.message }));        
      } else {
        dispatch(failure(error));      
      }
    }
  };

  function request() { return { type: ldapConstants.TEST_REQUEST } }
  function success(testResult) { return { type: ldapConstants.TEST_SUCCESS, testResult } }
  function failure(testResult) { return { type: ldapConstants.TEST_FAILURE, testResult } }
}

function remove(id) {
  return async dispatch => {
    dispatch(request());
    try {
      await ldapService.remove(id);
      dispatch(success(true));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: ldapConstants.REMOVE_REQUEST } }
  function success(ldapServer) { return { type: ldapConstants.REMOVE_SUCCESS, ldapServer } }
  function failure(error) { return { type: ldapConstants.REMOVE_FAILURE, error } }
}

function fetch(params) {
  return async dispatch => {
    dispatch(request());

    try {
      const ldapServers = await ldapService.fetch(params);

      dispatch(success(ldapServers));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: ldapConstants.FETCH_REQUEST } }
  function success(ldapServers) { return { type: ldapConstants.FETCH_SUCCESS, ldapServers } }
  function failure(error) { return { type: ldapConstants.FETCH_FAILURE, error } }
}

function get(id) {
  return async dispatch => {
    dispatch(request());

    try {
      const ldapServer = await ldapService.get(id);
      dispatch(success(ldapServer));
    } catch(error) {
      dispatch(failure(error));
      dispatch(alertActions.error(error));
    }
  };

  function request() { return { type: ldapConstants.GET_REQUEST } }
  function success(ldapServer) { return { type: ldapConstants.GET_SUCCESS, ldapServer } }
  function failure(error) { return { type: ldapConstants.GET_FAILURE, error } }
}


